export const getMoneyFromCentsAndFractions = (cents = 0, fractions = 0) => {
    if (!cents) return 0;

    return cents / Math.pow(10, fractions);
};
